import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate'; 
import StampWorkScheduleChangeApplication from 'components/organismos/master/attend/StampWorkScheduleChangeApplication';

const WorkScheduleChangeApplication: React.FC = () => (
  <SidebarTemplate >
    <StampWorkScheduleChangeApplication />
  </SidebarTemplate>
);

export default WorkScheduleChangeApplication;
